import { forwardRef, type ChangeEvent, type MouseEvent } from 'react'

import { AUDIO_FILE_ACCEPT } from '@core/models'

type TUploadFileInputProps = {
    onSelectFiles: (files: File[]) => void
    /** audio-web reports the upload click here, not on the button. */
    onPickerOpen: () => void
    testID?: string
}

/**
 * Must stay mounted above the header and the mobile drawer: the drawer unmounts its content on
 * close, which would kill the pending `change` event.
 */
export const UploadFileInput = forwardRef<HTMLInputElement, TUploadFileInputProps>(
    ({ onSelectFiles, onPickerOpen, testID }, ref) => {
        const handleClick = (event: MouseEvent<HTMLInputElement>) => {
            const input = event.currentTarget

            // Reset so re-picking the same file still fires `change`.
            input.value = ''
            onPickerOpen()
        }

        const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
            const files = Array.from(event.currentTarget.files ?? [])

            if (files.length > 0) {
                onSelectFiles(files)
            }
        }

        return (
            <input
                ref={ref}
                hidden
                multiple
                type="file"
                accept={AUDIO_FILE_ACCEPT}
                onClick={handleClick}
                onChange={handleChange}
                data-test={testID}
            />
        )
    },
)
